export function AutoIncrementer(initArray, offset = 0, perPage=15) {
    const finalArray = [];
    for(let i = 0; i < initArray.length; i++) {
        initArray[i]['priority'] = (i+1) + (offset*perPage);
        finalArray.push(initArray[i]);
    }
    return finalArray;
}